<!-- 资源-选择习题-吴影茹 -->
<template>
  <div>
    <!-- 标题 -->
    <div class="resource_select_title">选择习题</div>
    <!-- 搜索 -->
    <div class="row_center question_select_box">
      <ChapterSelect placeholder="请选择教材" @select="textbookSelectHandler" :data="defaultTextbookData" v-model:reset="resetValue" width="100%" />
    </div>
    <div class="row_center question_select_box" style="margin-top: 10px">
      <a-select v-model:value="formModal.type" :options="typeList1" style="flex: 1" placeholder="请选择题型"></a-select>
      <a-select
        v-model:value="formModal.questionType"
        :options="typeList2"
        style="flex: 1"
        v-show="formModal.type != '2'"
        placeholder="请选择笔试题题型"
      ></a-select>
    </div>
    <div class="row_center_end" style="margin-top: 15px">
      <a-button @click="reset" class="button_margin_right">重置</a-button>
      <a-button @click="getList(true)" type="primary">搜索</a-button>
    </div>
    <!-- 列表 -->
    <div class="question_select_list" v-if="dataSource.length != 0">
      <div class="question_select_item" v-for="(item, index) in dataSource" :key="index">
        <!-- 基础信息 -->
        <div class="row_between">
          <div class="row_center">
            <!-- 题型 -->
            <a-tag color="processing">{{
              typeList1.find((i) => {
                return i.value == item.type
              })?.label || '-'
            }}</a-tag>
            <!-- 笔试题型 -->
            <a-tag color="processing" v-if="item.type == 1">{{
              typeList2.find((i) => {
                return i.value == item.questionType
              })?.label || '-'
            }}</a-tag>
          </div>
          <!-- 难度 -->
          <div class="row_center question_select_item_box">
            <a-rate :value="item.difficulty" disabled allow-half style="font-size: 16px" />
            <div class="question_select_item_star">{{ item.difficulty + '星' }}</div>
          </div>
        </div>
        <!-- 笔试题-题干 -->
        <div style="margin-top: 22px; margin-bottom: 12px" v-if="item.type == 1">
          <div v-html="item.articleContent" class="text_overflow" style="-webkit-line-clamp: 5"></div>
        </div>
        <!-- 笔试题-选项 -->
        <div
          v-if="item.type == 1 && (item.questionType == 1 || item.questionType == 2 || item.questionType == 3)"
          class="column_start"
          style="gap: 5px"
        >
          <div v-for="[key, value] in Object.entries(JSON.parse(item.questionOptions))" :key="key" class="row_start">
            <div>{{ key }}</div>
            <div v-html="value"></div>
          </div>
        </div>
        <!-- 听力题 -->
        <div v-if="item.type == 2" style="margin-top: 20px" class="row_between">
          <audio :src="item.audioUrl" controls style="width: 85%"></audio>
          <div class="question_select_item_text">{{ '题数：' + item.questionsNumber }}</div>
        </div>
        <!-- 答案+分数 -->
        <div class="question_select_item_score_box">
          <!-- 标准答案-仅单选题、多选题、填空题有此信息 -->
          <div
            class="question_select_item_text"
            v-if="item.type == 1 && (item.questionType == 1 || item.questionType == 2 || item.questionType == 3)"
          >
            {{ '标准答案：A' }}
          </div>
          <!-- 分值 -->
          <div class="question_select_item_text">{{ '分值：' + item.score + '分' }}</div>
        </div>
        <!-- 章节信息 -->
        <div class="question_select_item_text">{{ '章节信息：' + item.textbookGroupName }}</div>
        <!-- 其他信息 -->
        <div class="row_between" style="margin-top: 20px">
          <!-- 创建人+创建时间 -->
          <div style="flex: 1">
            <div class="question_select_item_text" style="margin-bottom: 8px">{{ '创建人：' + item.createBy }}</div>
            <div class="question_select_item_text">{{ item.createTime }}</div>
          </div>
          <!-- 按钮 -->
          <div class="row_center">
            <a-button @click="detailHandler(item)" class="button_margin_right">预览</a-button>
            <a-button type="primary" :disabled="isSelected(item)" @click="selectHandler(item)">{{ isSelected(item) ? '已添加' : '添加' }}</a-button>
          </div>
        </div>
      </div>
    </div>
    <!-- 空状态 -->
    <div v-else>
      <OyEmpty style="margin: 30px 0 70px 0" />
    </div>
    <!-- 分页 -->
    <div class="row_center_end">
      <a-pagination
        v-model:current="pageNum"
        v-model:pageSize="pageSize"
        :total="total"
        show-less-items
        :show-total="() => `共 ${total} 条`"
        @change="pageChange"
      />
    </div>
  </div>
</template>
            
<script setup lang="ts">
import { onMounted, ref, getCurrentInstance, nextTick, watch } from 'vue'
import { questionInfo } from './types'
import * as api from './service'
import { useRouter } from 'vue-router'
const router = useRouter()
import { useDict } from '@/composable/useDict'
const { getDictData } = useDict()

const props = defineProps({
  // 已选数据数据
  list: {
    type: Array as () => Array<any>,
    default: () => []
  },
  //   需要传入的章节信息参数
  defaultTextbookData: {
    type: Object,
    default: () => {}
  }
})

onMounted(async () => {
  await getTypeList1()
  await getTypeList2()
  getList(true)
})
const emit = defineEmits(['update:list'])

// 列表数据
const dataSource = ref<any[]>([])
const formModal = ref<any>({
  type: null,
  questionType: null
})

// 章节信息选择
const textbookData = ref<any>({})

// 获取习题列表数据
// init 是否需要清空列表数据再拉取数据
const getList = (init = false) => {
  if (init) {
    dataSource.value = []
    pageNum.value = 1
    total.value = 0
  }

  for (const key in textbookData.value) {
    if (textbookData.value[key] === '' || textbookData.value[key] === null) {
      delete textbookData.value[key]
    }
  }
  //   api.coursewareList({ params: { textbook: textbookData.value, status: 1 }, pageNum: pageNum.value, pageSize: pageSize.value }).then((res) => {
  //     dataSource.value = res.data.list
  //     total.value = res.data.total
  //   })

  var tempList: any = [
    {
      questionId: '64641538645',
      type: '1',
      questionType: '1',
      textbookGroupName: '初一年级数学上册 · 第一单元 · 第一章',
      articleContent: '下列哪个是一次函数的图像？',
      difficulty: 3,
      questionOptions: {
        A: '抛物线',
        B: '直线',
        C: '双曲线',
        D: '弧线'
      },
      correctAnswer: { A: '抛物线' },
      score: 5,
      createBy: '张三',
      createTime: '2025-06-01 12:00:00'
    },
    {
      questionId: '9846515815',
      type: '1',
      questionType: '2',
      textbookGroupName: '初一年级数学上册 · 第一单元 · 第一章',
      articleContent: '下列哪个是一次函数的图像？',
      difficulty: 1,
      questionOptions: {
        A: '抛物线',
        B: '直线',
        C: '双曲线',
        D: '弧线'
      },
      correctAnswer: { A: '抛物线', D: '弧线' },
      score: 3,
      createBy: '张三',
      createTime: '2025-06-01 12:00:00'
    },
    {
      questionId: '94616541',
      type: '1',
      questionType: '7',
      textbookGroupName: '初一年级数学上册 · 第一单元 · 第一章',
      articleContent:
        '下列哪个是一次函数的图像？下列哪个是一次函数的图像？下列哪个是一次函数的图像？下列哪个是一次函数的图像？下列哪个是一次函数的图像？下列哪个是一次函数的图像？下列哪个是一次函数的图像？下列哪个是一次函数的图像？下列哪个是一次函数的图像？下列哪个是一次函数的图像？下列哪个是一次函数的图像？下列哪个是一次函数的图像？下列哪个是一次函数的图像？下列哪个是一次函数的图像？下列哪个是一次函数的图像？下列哪个是一次函数的图像？下列哪个是一次函数的图像？下列哪个是一次函数的图像？下列哪个是一次函数的图像？下列哪个是一次函数的图像？下列哪个是一次函数的图像？下列哪个是一次函数的图像？下列哪个是一次函数的图像？下列哪个是一次函数的图像？下列哪个是一次函数的图像？下列哪个是一次函数的图像？下列哪个是一次函数的图像？下列哪个是一次函数的图像？下列哪个是一次函数的图像？下列哪个是一次函数的图像？下列哪个是一次函数的图像？下列哪个是一次函数的图像？下列哪个是一次函数的图像？下列哪个是一次函数的图像？下列哪个是一次函数的图像？下列哪个是一次函数的图像？',
      difficulty: 4,
      score: 8,
      createBy: '张三',
      createTime: '2025-06-01 12:00:00'
    },
    {
      questionId: '96841654',
      type: '2',
      questionType: '',
      textbookGroupName: '初一年级数学上册 · 第一单元 · 第一章',
      audioUrl: '/1.mp3',
      // 小题数量
      questionsNumber: 5,
      difficulty: 4,
      score: 8,
      createBy: '张三',
      createTime: '2025-06-01 12:00:00'
    }
  ]

  tempList = tempList.map((item) => {
    return {
      ...item,
      questionOptions: item.questionOptions ? JSON.stringify(item.questionOptions) : null,
      correctAnswer: item.correctAnswer ? JSON.stringify(item.correctAnswer) : null
    }
  })

  dataSource.value = tempList.map((item) => {
    return {
      ...item
    }
  })
}

// 分页配置
const pageNum = ref<Number>(1)
const pageSize = ref<Number>(5)
const total = ref<Number>(0)
const pageChange = (page: Number) => {
  pageNum.value = page
  getList()
}

// 选择章节信息
const textbookSelectHandler = (e) => {
  if (e[0]) textbookData.value.studyPeriod = e[0]
  if (e[1]) textbookData.value.gradeCode = e[1]
  if (e[2]) textbookData.value.subjectCode = e[2]
  if (e[3]) textbookData.value.volumeCode = e[3]
  if (e[4]) textbookData.value.versionId = e[4]
  if (e[6]) textbookData.value.parentChapterId = e[6]
  textbookData.value.chapterId = e[7] || ''
}

// 题型列表
const typeList1 = ref<any[]>([])
// 获取题型列表
const getTypeList1 = async () => {
  typeList1.value = await getDictData('question_type1')
}

// 笔试题题型列表
const typeList2 = ref<any[]>([])
// 获取笔试题题型列表
const getTypeList2 = async () => {
  typeList2.value = await getDictData('question_type2')
}

// 已选习题列表
const selectedList = ref<any>([])
// 是否已选
const isSelected = (item: any) => {
  return selectedList.value.some((i) => i.questionId === item.questionId)
}

// 预览
const previewVisible = ref(false)
const previewId = ref<string>('')
const detailHandler = (item: any) => {
  previewVisible.value = true
  previewId.value = item.questionId
}

// 选择
const selectHandler = (item: any) => {
  var index = selectedList.value.findIndex((i) => {
    return i.questionId == item.questionId
  })
  if (index == -1) {
    selectedList.value.push({ ...item })
  } else {
    selectedList.value.splice(index, 1)
  }

  emit('update:list', selectedList.value)
}

// 重置
const resetValue = ref(false)
const reset = () => {
  resetValue.value = true
  textbookData.value = {}
  formModal.value.type = null
  formModal.value.questionType = null
  getList(true)
}

watch(
  () => props.list,
  (newVal) => {
    if (newVal && newVal.length != 0) {
      selectedList.value = newVal.map((item) => {
        return { ...item }
      })
    }
  },
  { immediate: true, deep: true }
)

watch(
  () => props.defaultTextbookData,
  (newVal) => {
    if (Object.keys(newVal).length != 0) {
      if (newVal[0]) textbookData.value.studyPeriod = newVal[0]
      if (newVal[1]) textbookData.value.gradeCode = newVal[1]
      if (newVal[2]) textbookData.value.subjectCode = newVal[2]
      if (newVal[3]) textbookData.value.volumeCode = newVal[3]
      if (newVal[4]) textbookData.value.versionId = newVal[4]
      if (newVal[6]) textbookData.value.parentChapterId = newVal[6]
      if (newVal[7]) textbookData.value.chapterId = newVal[7]
      getList(true)
    }
  },
  { immediate: true, deep: true }
)
</script>
            
<style lang="scss" scoped>
.question_select_box {
  margin-top: 20px;
  gap: 15px;
}
.question_select_list {
  margin-top: 20px;
}
.question_select_item {
  border-radius: 15px;
  border: 1px solid #e5e7eb;
  padding: 20px;
  margin-bottom: 20px;
}
.question_select_item_box {
  ::v-deep(.ant-rate-star:not(:last-child)) {
    margin-inline-end: 4px;
  }
}
.question_select_item_star {
  font-size: 14px;
  color: #6b7280;
  line-height: 14px;
  margin-left: 8px;
  margin-top: 2px;
}
.question_select_item_text {
  font-size: 14px;
  color: #6b7280;
}
.question_select_item_score_box {
  background-color: #f9fafb;
  font-size: 14px;
  color: #6b7280;
  border-radius: 10px;
  padding: 15px;
  margin: 15px 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
</style>